export default __webpack_public_path__ + "static/latitude-scam-alert-5-b1b79ccaf5823ee8b21f3e29a4bae644.webp";